import {debug} from "../utils";

export const ACTION_SYSTEM_DATA_LOADED = "ACTION_SYSTEM_DATA_LOADED";

const initState = {
    cpu: {
        currentLoad: 0,
        currentLoadUser: 0,
        currentLoadSystem: 0,
        manufacturer: 'Unknown CPU',
        brand: '',
        speed: ''
    },
    mem: {
        total: 'Unknown',
        free: 'Unknown',
        used: 'Unknown',
        buffers: 'Unknown',
        cached: 'Unknown'
    },
    disk: {
        size: 0,
        used: 0,
        available: 0,
        rxSec: 0,
        wxSec: 0
    },
    avgResponse: 0,
    loading: true
}


export function SystemPageReducer(state = initState, action) {
    switch (action.type) {
        case ACTION_SYSTEM_DATA_LOADED: {
            debug(`SystemPageReducer ${ACTION_SYSTEM_DATA_LOADED} is being processed...`, state, action)
            return {
                referer: state.referer,
                ...action.payload,
                loading: false,
            }
        }
        default:
            return state;
    }
}